/**
 * @param {string|number} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function phone ({ value, validationValue }) {
  if (!validationValue) return true

  // Remove all characters except numbers
  const val = value
    ?.toString()
    ?.trim()
    ?.replace(/[^0-9]/g, '')

  if (val?.length !== 8) return false

  let isLandline = false
  let isMobile = false

  const firstDigit = parseInt(val.substr(0, 1), 10)
  const secondDigit = parseInt(val.substr(1, 1), 10)
  const firstFourDigits = parseInt(val.substr(0, 4), 10)

  if (firstFourDigits === 4747) return false

  if ([2, 3, 6, 7].includes(firstDigit)) isLandline = true
  if (firstDigit === 5 && secondDigit >= 0 && secondDigit <= 7) isLandline = true

  if ([4, 9].includes(firstDigit)) isMobile = true
  if (firstDigit === 5 && secondDigit === 9) isMobile = true

  return isLandline || isMobile
}

module.exports = { phone }
